export const debounce = (fn, wait) => {
  let timeoutId = null;
  return (...args) => {
    if (timeoutId) {
      return;
    }
    timeoutId = setTimeout(() => {
      fn(...args);
      clearTimeout(timeoutId);
      timeoutId = null;
    }, wait);
  };
};
